import React, { useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import close from "../../assets/close.svg";
import open from "../../assets/open.svg";
import { useInterceptor } from "providers/InterceptorProvider";
import { useEffect } from "react";
import axios from "axios";
import LoginPopup from "components/Auth/LoginPopup";

const Faq = () => {
  const { api } = useInterceptor();
  const [openQues, setOpenQues] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  async function fetchFAQ() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/faq`
      );
      setQuestions(response.data.data);
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    fetchFAQ();
  }, [api]);

  const handleQuesOpen = (index) => {
    setOpenQues((prevOpenQues) => [...prevOpenQues, index]);
  };
  const handleQuesClose = (index) => {
    setOpenQues((prevOpenQues) => prevOpenQues.filter((ques) => ques != index));
  };
  return (
    // min-[1500px]:flex min-[1500px]:flex-col min-[1500px]:justify-center min-[1500px]:items-center
    <div className="">
      <Header onLoginClick={() => setShowLoginPopup(true)} />

      {showLoginPopup && (
        <LoginPopup
          onClose={() => setShowLoginPopup(false)}
          onLoginSuccess={() => {}}
        />
      )}

      <div className="max-w-[1200px] mx-auto min-h-[91vh]">
        <div className="mb-12 font-inter">
          <h5 className="border border-[#17773B] rounded-full w-min px-4 py-[1px] mt-11 text-[#17773B] text-[14px]">
            SUPPORT
          </h5>
          <h1 className="text-[42px] font-[500] tracking-wide">Need Help?</h1>
          <p className="text-xl">
            Everything you need to know about the SentioCap
          </p>
        </div>

        {questions.map((question, index) => (
          <div
            className={`font-inter px-7 py-4 border mb-4 border-[#D9D9D9] rounded-[10px] ${
              index === questions.length - 1 && ""
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="text-xl font-medium">{question.name}</div>
              {openQues.includes(index) ? (
                <img
                  src={close}
                  alt=""
                  className="cursor-pointer py-1"
                  onClick={() => handleQuesClose(index)}
                />
              ) : (
                <img
                  src={open}
                  alt=""
                  className="cursor-pointer"
                  onClick={() => handleQuesOpen(index)}
                />
              )}
            </div>
            <div
              className={`text-[18px] w-[95%] mt-3 ${
                openQues.includes(index) ? "" : "hidden"
              }`}
            >
              {question.values[0].value}
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Faq;
